import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { ApplicationConfig, ErrorHandler, inject, isDevMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, TitleStrategy, withComponentInputBinding, withPreloading } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApplicationInsightsErrorHandler } from 'finzzle-angular-utils';
import { OperationTypeNode } from 'graphql';
import { omitDeep } from 'lodash-omitdeep';
import * as echarts from 'echarts';
import { provideEchartsCore } from 'ngx-echarts';
import { OuiDialogService } from 'omnium-ui/dialog';
import { PageTitleStrategy } from '@lib/services/page-title.strategy';
import { routes } from './app.routes';
import { environment } from './environments/environment';
import { AuthInterceptorInterceptor } from './interceptors/auth-interceptor.interceptor';

registerLocaleData(localeFr, 'fr-FR');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthInterceptorInterceptor },
    { provide: 'environment', useValue: environment },
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
    { provide: OuiDialogService },
    CurrencyPipe,
    DatePipe,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideZoneChangeDetection(),
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    provideEchartsCore({ echarts }),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const removeTypeNameFromMutation = new ApolloLink((operation, forward) => {
        const definition = operation?.query?.definitions.filter(def => def.kind === 'OperationDefinition')?.[0];
        const mutation: OperationTypeNode = OperationTypeNode.MUTATION;
        if (definition?.kind == 'OperationDefinition' && definition?.operation === mutation) {
          operation.variables = omitDeep(operation.variables, '__typename');
          return forward(operation);
        }
        return forward(operation);
      });
      return {
        link: removeTypeNameFromMutation.concat(httpLink.create({ uri: environment.backEndUrl })),
        cache: new InMemoryCache(),
        defaultOptions: {
          query: {
            errorPolicy: 'all',
          },
          mutate: {
            errorPolicy: 'all',
          },
          watchQuery: {
            errorPolicy: 'all',
          },
        },
      };
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
